<template>
  <keep-alive :include="includeComponents">
    <component ref="navigate"
               :is="currComponent"
               @navigate-to="navigateTo"
               @reset="handleReset"
               v-bind="currParams"
               v-on="$listeners"></component>
  </keep-alive>
</template>

<script>
export default {
  name: 'NavigateContainer',
  props: {
    pages: {
      type: Array,
      required: true,
      validator: function (pages) {
        if (pages.length) {
          return pages.every((page, index) => !pages.some((p, i) => index !== i && page === p))
        }
      }
    },
    pageResolver: {
      type: Function,
      required: true
    },
    page: {
      type: String
    }
  },
  data () {
    return {
      currPage: null,
      pageParams: {},
      componentMap: {}
    }
  },
  computed: {
    currPageIndex () {
      return this.pages.indexOf(this.currPage)
    },
    currComponent () {
      let component = this.pageResolver(this.currPage)
      let componentMap = this.componentMap
      if (component) {
        let compName = `NavigateComponent_${this.currPageIndex}`
        let getComp
        if (this.includeComponents.includes(compName)) {
          getComp = componentMap[compName]
        }
        if (!getComp) {
          getComp = {
            name: compName,
            extends: component
          }
          componentMap[compName] = getComp
        }
        return getComp
      }
    },
    currParams () {
      return this.$extend(this.$attrs, this.pageParams[this.currPage])
    },
    includeComponents () {
      let array = []
      for (let i = 0; i <= this.currPageIndex; i++) {
        array.push(`NavigateComponent_${i}`)
      }
      return array
    }
  },
  methods: {
    navigateTo (page, params) {
      if (this.currPage !== page && this.pages.includes(page)) {
        this.triggerEvent('onHide')
        this.currPage = page
        if (params) {
          this.$set(this.pageParams, page, this.$extend(this.pageParams[page], params))
        }
        this.$nextTick(() => {
          this.triggerEvent('onShow')
        })
      }
    },
    triggerEvent (eventName) {
      let navigate = this.$refs.navigate
      if (navigate) {
        let event = navigate[eventName]
        typeof event === 'function' && event()
      }
    },
    handleReset () {
      this.currPage = null
      this.pageParams = {}
      this.$nextTick(() => this.initNavigate())
    },
    initNavigate () {
      this.navigateTo(this.page && this.pages.includes(this.page) ? this.page : this.pages[0])
    }
  },
  mounted () {
    this.initNavigate()
  },
  watch: {
    currPage: {
      handler: function (val) {
        this.$emit('update:page', val)
        this.$nextTick(() => {
          let currPageIndex = this.currPageIndex
          if (currPageIndex >= 0) {
            let cachePages = this.pages.slice(0, currPageIndex + 1)
            Object.keys(this.pageParams).forEach(key => {
              if (!cachePages.includes(key)) {
                this.$delete(this.pageParams, key)
              }
            })
          }
        })
      },
      immediate: true
    }
  }
}
</script>
